import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "headline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_combobox_filled = _resolveComponent("v-combobox-filled")!
  const _component_v_btn_ternary = _resolveComponent("v-btn-ternary")!
  const _component_oss_company_activities_selector = _resolveComponent("oss-company-activities-selector")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_AccountableAccount = _resolveComponent("AccountableAccount")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_ScopeManager = _resolveComponent("ScopeManager")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_company_table = _resolveComponent("company-table")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: "",
    class: "pb-0 mb-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "default_card large mx-0 my-2 pa-2",
        elevation: "0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: _ctx.enablePublish || _ctx.enablehUnpublish ? '8' : '10'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_back, {
                    class: "mr-4",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.goBack()), ["stop"]))
                  }),
                  _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.title), 1)
                ]),
                _: 1
              }, 8, ["cols"]),
              _createVNode(_component_v_col, {
                cols: _ctx.enablePublish || _ctx.enablehUnpublish ? '4' : '2',
                class: "d-flex justify-end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_primary, {
                    rounded: "",
                    block: "",
                    disabled: _ctx.isDisabled,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.upload())),
                    "data-cy": "DocumentRuleSheet-cta"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.patternId ? "Modifier" : "Créer"), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }, 8, ["cols"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        style: _normalizeStyle('max-height:' + _ctx.maxHeight + ';' + 'overflow:auto')
      }, [
        (_ctx.profile.configuration.accountingRule.read)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              class: "scrolled-card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex justify-start align-center pb-2"
                    }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createElementVNode("h2", null, "Conditions : Fournisseur(s) / Client(s) / Activité(s)", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "pt-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "1",
                      class: "d-flex align-center justify-center"
                    }, {
                      default: _withCtx(() => _cache[18] || (_cache[18] = [
                        _createTextVNode(" Pour ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "2" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select_filled, {
                          modelValue: _ctx.companyIdentifier,
                          "onUpdate:modelValue": [
                            _cache[2] || (_cache[2] = ($event: any) => ((_ctx.companyIdentifier) = $event)),
                            _cache[3] || (_cache[3] = ($event: any) => (_ctx.emptyConditions()))
                          ],
                          items: _ctx.identifyCompaniesBy,
                          "hide-details": true,
                          readonly: _ctx.readonly,
                          density: "compact"
                        }, null, 8, ["modelValue", "items", "readonly"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "8",
                      class: "pl-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_combobox_filled, {
                          modelValue: _ctx.conditionPropToShow,
                          "onUpdate:modelValue": [
                            _cache[4] || (_cache[4] = ($event: any) => ((_ctx.conditionPropToShow) = $event)),
                            _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateConditions()))
                          ],
                          label: 
                                _ctx.companyIdentifier === 'activity'
                                    ? 'sur ces activités'
                                    : _ctx.companyIdentifier === 'siren'
                                      ? 'sur ces siren'
                                      : 'sur ces sociétés'
                            ,
                          multiple: "",
                          density: "compact",
                          chips: "",
                          rules: _ctx.sirenRules,
                          readonly: _ctx.companyIdentifier !== 'siren'
                        }, {
                          chip: _withCtx(({ index }) => [
                            _createVNode(_component_v_chip, {
                              class: "ma-2 pa-2",
                              closable: "",
                              "close-icon": "$close",
                              "onClick:close": ($event: any) => (_ctx.conditionPropToShow.splice(index, 1))
                            }, null, 8, ["onClick:close"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "label", "rules", "readonly"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      col: "1",
                      class: "d-flex align-center justify-center pl-2"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.companyIdentifier === 'siren' || _ctx.companyIdentifier === 'company')
                          ? (_openBlock(), _createBlock(_component_v_btn_ternary, {
                              key: 0,
                              size: "x-small",
                              fab: "",
                              elevation: "0",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.dialogSelectCondition = !_ctx.dialogSelectCondition)),
                              icon: "$fa-building"
                            }))
                          : (_openBlock(), _createBlock(_component_oss_company_activities_selector, {
                              key: 1,
                              modelValue: _ctx.activitiesSelected,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.activitiesSelected) = $event)),
                              multiple: true,
                              button: true
                            }, null, 8, ["modelValue"]))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "py-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_divider)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "my-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex justify-start align-center"
                    }, {
                      default: _withCtx(() => _cache[19] || (_cache[19] = [
                        _createElementVNode("h3", null, "Compte tiers", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "2",
                      class: "d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_switch, {
                          modelValue: _ctx.withThirdParty,
                          "onUpdate:modelValue": [
                            _cache[8] || (_cache[8] = ($event: any) => ((_ctx.withThirdParty) = $event)),
                            _ctx.resetTP
                          ],
                          label: "Activer",
                          readonly: _ctx.readonly
                        }, null, 8, ["modelValue", "readonly", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    (_ctx.assignedCompanyCount !== 1 || !_ctx.uniqueAssignedCompanyId)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "5"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_AccountableAccount, {
                              btnMode: false,
                              label: ' ',
                              showValidation: false,
                              showDescription: true,
                              inAccountableAccounts: _ctx.accountableAccountsCFSTF,
                              inAccountableAccount: 
                                _ctx.specs.rules && _ctx.specs.rules.thirdPartyAccountableAccount
                            ,
                              disabled: !_ctx.withThirdParty || _ctx.readonly,
                              hideDetails: true,
                              onSelectAccountableAccount: _ctx.selectThirdPartyAccountableAccount,
                              defineThirdParty: true
                            }, null, 8, ["inAccountableAccounts", "inAccountableAccount", "disabled", "onSelectAccountableAccount"]), [
                              [_vShow, true]
                            ])
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_col, {
                          key: 1,
                          cols: "5"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_AccountableAccount, {
                              btnMode: false,
                              label: ' ',
                              showValidation: false,
                              showDescription: true,
                              companyId: _ctx.uniqueAssignedCompanyId,
                              inAccountableAccounts: _ctx.accountableAccountsCFSTF,
                              inAccountableAccount: 
                                _ctx.specs.rules && _ctx.specs.rules.thirdPartyAccountableAccount
                            ,
                              disabled: !_ctx.withThirdParty || _ctx.readonly,
                              hideDetails: true,
                              thirdParty: 
                                _ctx.specs.thirdParty || _ctx.specs.thirdPartyCompany || _ctx.specs.thirdPartyUser
                            ,
                              defineThirdParty: true,
                              onSelectAccountableAccount: _ctx.selectThirdPartyAccountableAccount
                            }, null, 8, ["companyId", "inAccountableAccounts", "inAccountableAccount", "disabled", "thirdParty", "onSelectAccountableAccount"]), [
                              [_vShow, true]
                            ])
                          ]),
                          _: 1
                        })),
                    _createVNode(_component_v_col, {
                      cols: "5",
                      class: "d-flex align-center pl-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field_filled, {
                          readonly: "",
                          style: {"pointer-events":"none"},
                          label: "Tiers",
                          "model-value": _ctx.thirdPartyTitle,
                          density: "compact"
                        }, null, 8, ["model-value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "my-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex justify-start align-center"
                    }, {
                      default: _withCtx(() => _cache[20] || (_cache[20] = [
                        _createElementVNode("h3", null, "Affectation à un compte de charge ou produit", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "2",
                      class: "d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_switch, {
                          modelValue: _ctx.withAccountableAccount,
                          "onUpdate:modelValue": [
                            _cache[9] || (_cache[9] = ($event: any) => ((_ctx.withAccountableAccount) = $event)),
                            _ctx.resetAA
                          ],
                          label: "Activer",
                          readonly: _ctx.readonly
                        }, null, 8, ["modelValue", "readonly", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: 10 }, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_AccountableAccount, {
                          btnMode: false,
                          label: ' ',
                          showValidation: false,
                          showDescription: true,
                          companyId: _ctx.uniqueAssignedCompanyId,
                          inAccountableAccounts: _ctx.purchaseAndSalesAAs,
                          inAccountableAccount: _ctx.specs.rules && _ctx.specs.rules.accountableAccount,
                          disabled: !_ctx.withAccountableAccount || _ctx.readonly,
                          hideDetails: true,
                          onSelectAccountableAccount: _ctx.selectAccountableAccount
                        }, null, 8, ["companyId", "inAccountableAccounts", "inAccountableAccount", "disabled", "onSelectAccountableAccount"]), [
                          [_vShow, true]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "py-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_divider)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "my-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex justify-start align-center"
                    }, {
                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                        _createElementVNode("h3", null, "Étiquettes", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_combobox_filled, {
                          modelValue: _ctx.specs.rules.tags,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.specs.rules.tags) = $event)),
                          multiple: "",
                          outlined: "",
                          dense: "",
                          chips: "",
                          "item-disabled": ""
                        }, {
                          chip: _withCtx(({ index }) => [
                            _createVNode(_component_v_chip, {
                              class: "ma-2 pa-2",
                              closable: "",
                              "close-icon": "$close",
                              "onClick:close": ($event: any) => (_ctx.specs.rules.tags.splice(index, 1))
                            }, null, 8, ["onClick:close"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_ScopeManager, {
          ref: "scopeManager",
          modelValue: _ctx.scopeSync,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.scopeSync) = $event)),
          id: _ctx.scopeId,
          "onUpdate:id": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.scopeId) = $event)),
          name: _ctx.scopeName,
          "onUpdate:name": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.scopeName) = $event)),
          readonly: _ctx.readonly,
          initialCompany: _ctx.initialCompany
        }, null, 8, ["modelValue", "id", "name", "readonly", "initialCompany"])
      ], 4),
      _createVNode(_component_v_snackbar, {
        modelValue: _ctx.snackbarActive,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.snackbarActive) = $event))
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.snackbarActive = false)),
            variant: "text"
          }, {
            default: _withCtx(() => _cache[22] || (_cache[22] = [
              _createTextVNode(" Close ")
            ])),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.snackbarText) + " ", 1)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_ctx.dialogSelectCondition)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 0,
            modelValue: _ctx.dialogSelectCondition,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.dialogSelectCondition) = $event)),
            title: 'Sélectionnez les sociétés tiers',
            width: "800px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_company_table, {
                showGenericCompany: false,
                showNewCompanies: true,
                wizardMode: true,
                onSelectCompany: _ctx.companiesSelected
              }, null, 8, ["onSelectCompany"])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}